import { Money, DiscountSimpleData } from "../dto/EntityRepository";


export const renderingPrice = (price: Money): string => {
  if (price == null) return "";
  if (price.amount === 0 || !price.amount) return "";

  const newPrice = digitGrouping(price.amount.toString());
  return newPrice;
};

const digitGrouping = (price: string): string => {
  if (price === null) return "";
  price = price.replaceAll(",", "");
  price = price.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  return price;
};

export const cleanUpPrice = (price: string): string => {
  if (!price || typeof price !== 'string') return "";
  return price.replaceAll(",", "");
};

/**
 * 할인 금액을 표시용으로 포맷팅
 * @param discount 할인 데이터
 * @returns 포맷팅된 할인 금액 문자열 (예: "$10.00")
 */
export const formatDiscountAmount = (discount: DiscountSimpleData): string => {
  if (!discount || discount.amount === 0) return "";
  
  // amount는 센트 단위이므로 100으로 나누어 달러로 변환
  const dollarAmount = discount.amount / 100;
  
  // 통화 코드를 대문자로 변환하고 심볼 매핑
  const currencySymbol = getCurrencySymbol(discount.currency.toUpperCase());
  
  // 소수점 2자리까지 포맷팅
  const formattedAmount = dollarAmount.toFixed(2);
  
  return `${currencySymbol}${formattedAmount}`;
};

/**
 * 통화 코드를 통화 심볼로 변환
 * @param currency 통화 코드 (예: "USD", "KRW")
 * @returns 통화 심볼 (예: "$", "₩")
 */
export const getCurrencySymbol = (currency: string): string => {
  const currencyMap: Record<string, string> = {
    'USD': '$',
    'KRW': '₩',
    'JPY': '¥',
    'EUR': '€',
    'GBP': '£',
    'CNY': '¥',
    'AUD': 'A$',
    'CAD': 'C$',
    'CHF': 'CHF',
    'HKD': 'HK$',
  };
  
  return currencyMap[currency] || currency;
};
